import { tooltip } from './_base';

const Coins = () => {
  let value = 0;

  return {
    value,
    tooltip: () => tooltip('coins'),
    min: 0
  };
};

export default Coins;
